import Vue from 'vue';
import Vuex from 'vuex';
import sidebar from './modules/sidebar';
import header from './modules/header';
import parklock from './modules/parklock';

Vue.use(Vuex);

export default new Vuex.Store({ 
    modules:{
        sidebar,
        header,
        parklock
    } 
})


// WEBPACK FOOTER //
// ./src/store/index.js